import FormSubmissionSuccess from './FormSubmissionSuccess';

export default FormSubmissionSuccess;
